import React from 'react'
import {Link} from 'react-router-dom'
import './../../App.css'

const About = () =>{
    return(
 <React.Fragment>
     <div className="container about">
     <Link to ="/" className="btn btn-dark btn-sm mb-4 text-white">
Go back
  </Link>
 <h2 className="text-center">About Developer</h2>
 <p className="text-center"> O. Judith is a full stack web developer and content strategist, she is a tech-savvy and very
     passionate the world web web
 </p>
<h5 className="text-center">Credit/Attribution</h5>

 <p className="text-center">News source: <a href="https://newsapi.org/" rel="noopener noreferrer" target="_blank">NewsApi.org</a></p>
 <p className="text-center">Illustration: <a href="https://undraw.co/" rel="noopener noreferrer" target="_blank">unDraw.co</a></p>
 </div>
     </React.Fragment>
    )
}
export default About